<script>
import LoginForm from '../components/LoginForm.vue'

export default {
    name: 'Login',
    components: {
        LoginForm,
    },
    methods: {
        onLogin(userResource) {
            this.$router.push({ name: 'home' })
        },
    },
}
</script>

<template>
    <b-container v-page-title="'Login'">
        <b-row>
            <b-col lg="4" offset-lg="4" class="mt-5">
                <b-navbar-brand class="logo-text"><router-link :to="{ name: 'home' }">Node<strong>Jobs</strong></router-link></b-navbar-brand>
                <b-card>
                    <login-form @success="onLogin" />
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<style lang="scss">
.logo-text {
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
    padding-left: 25px;
    background-image: url(../assets/img/nodejobs-logo.png);
    background-repeat: no-repeat;
    background-size: 19.3px 22px;
    background-position-y: 9px;
    
    a {
        color: #fff;

        &:hover {
            text-decoration: none;
            color: #fff;
        }
    }
}
</style>
